import { o as otto } from "../chunks/common-nexus-client-CdICzBNm.mjs";
const viewport = otto.viewport ?? {};
const currentBreakpoint = viewport.currentBreakpoint;
const isActiveBreakpoint = viewport.isActiveBreakpoint;
const getCurrentBreakpoint = viewport.getCurrentBreakpoint;
const currentOrientation = viewport.currentOrientation;
const isActiveOrientation = viewport.isActiveOrientation;
const getCurrentOrientation = viewport.getCurrentOrientation;
const getScrollbarWidth = viewport.getScrollbarWidth;
export {
  currentBreakpoint,
  currentOrientation,
  getCurrentBreakpoint,
  getCurrentOrientation,
  getScrollbarWidth,
  isActiveBreakpoint,
  isActiveOrientation,
  viewport
};
/*                                        */
